import { WrapperComponent } from 'libs/forms/wrapper/wrapper.component';
import { Wrapper2Component } from 'libs/forms/wrapper/wrapper2.component';
import { AvoidCachePipe } from 'libs/modules/tunnelsante/pipes/avoid-cache.pipe';
import { FooterComponent } from '../components/footer/footer.component';
import { AssureInfoFormComponent } from '../components/insurances/assure-info-form/assure-info-form.component';
import { CarQuotationFormComponent } from '../components/insurances/car-quotation-form/car-quotation-form.component';
import { CarQuotationSubscriptionFormComponent } from '../components/insurances/car-quotation-subscription-form/car-quotation-subscription-form.component';
import { FiltreOffresB2CComponent } from '../components/insurances/filtre-offres-b2c/filtre-offres-b2c.component';
import { FormulaPickerB2CComponent } from '../components/insurances/formula-pickerB2C/formula-picker.component';
import { HealthAssureFormComponent } from '../components/insurances/health-assure-form/health-assure-form.component';
import { HealthAssureFormComponentB2C } from '../components/insurances/health-assure-formB2C/health-assure-form.component';
import { InfobulleDetailsGarantiesComponent } from '../components/insurances/health-assure-formB2C/infobulle/infobulle-details-garanties/infobulle-details-garanties.component';
import { HealthFamilyFormComponent } from '../components/insurances/health-family-form/health-family-form.component';
import { HealthQuotationFormComponent } from '../components/insurances/health-quotation-form/health-quotation-form.component';
import { HealthQuotationFormComponentB2C } from '../components/insurances/health-quotation-formB2C/health-quotation-form.component';
import { HealthSubscriptionFormComponent } from '../components/insurances/health-subscription-form/health-subscription-form.component';
import { InfosFormComponent } from '../components/insurances/infos-form/infos-form.component';
import { RectButtonComponent } from '../components/rect-button/rect-button.component';
import { SimpleLayoutComponent } from '../components/simple-layout/simple-layout.component';
import { ShowIfkAuthorizedDirective } from '../directives/show-if-authorized.directive';
import { ShowIfLinkAuthorizedDirective } from '../directives/show-if-link-authorized.directive';
import { DocumentStateToIndicatorPipe } from '../pipes/document-state.pipe';
import { ExtensionImagePipe } from '../pipes/extension-image.pipe';
import { KeyValueFilterPipe } from '../pipes/kvp.pipe';
import { PublicIdPipe } from '../pipes/public-id.pipe';
import { RoutePipe } from '../pipes/route.pipe';

export const wzCoreInsuranceExportedComponents = [
  FormulaPickerB2CComponent,

  HealthAssureFormComponent,
  HealthAssureFormComponentB2C,
  HealthFamilyFormComponent,

  HealthSubscriptionFormComponent,
];

export const wzCoreExportedComponents = [
  SimpleLayoutComponent,
  FooterComponent,
  RectButtonComponent,
  CarQuotationFormComponent,
  HealthQuotationFormComponent,
  HealthQuotationFormComponentB2C,
  InfosFormComponent,
  AssureInfoFormComponent,
  CarQuotationSubscriptionFormComponent,
  ...wzCoreInsuranceExportedComponents,
  WrapperComponent,
  Wrapper2Component,
  InfobulleDetailsGarantiesComponent,
  FiltreOffresB2CComponent,
  // RepeatTypeComponent,
  //   ClaimCommentWrapperComponent,
  //   StatusIconComponent
];

export const wzCoreExportedPipes = [
  // CarPropertyChangePipe,
  //CivilityPipe,
  AvoidCachePipe,
  RoutePipe,
  ExtensionImagePipe,
  DocumentStateToIndicatorPipe,
  PublicIdPipe,
  KeyValueFilterPipe,
];

export const wzCoreExportedDirectives = [
  ShowIfLinkAuthorizedDirective,
  ShowIfkAuthorizedDirective,
];

export const wzCoreEntryComponents = [
  // CarRiskDialogComponent,
  // StatusIconComponent,
];
